// mirrorHelpers.ts
import { useDesignStore } from "context/DesignContext";
import { Addition } from "models/Addition";
import { ConditionSide, Insole } from "models/Insole";
import { getDefaultSaveSettings, scheduleAutosave } from "components/Viewer3d/SaveManager"


export async function mirrorToLeft(): Promise<void> {
    useDesignStore.setState({ mirrorLoaded : true});
    
    const design = useDesignStore.getState().insoleDesign;

    if (!design) return;

    const left = design.insoles.find(ins => ins.side === "left");
    const right = design.insoles.find(ins => ins.side === "right");

    if (!left || !right) return;

    const rightCloned = Insole.cloneFrom(right);
    const mirroredGeom = rightCloned.mirror();
    if (mirroredGeom) {
        left.lowpolyBufferGeometry = mirroredGeom;
    }

    left.additions.length = 0;


    for (const addition of right.additions) {
        const cloned = Addition.cloneFrom(addition);
        cloned.foot = 'left';
        cloned.mirror();
        left.additions.push(cloned);
    }

    left.profileCurveType = right.profileCurveType;
    left.gcodeText = right.gcodeText;

    const props = design.autoProperties;
    if (props) {
        props.profileCurveLeft = props.profileCurveRight;
        props.heelDepthLeftY = props.heelDepthRightY;

        props.metatarSalBarLeft = -1;
        props.metatarSalPadLeft = -1;
        props.mortonsExtensionLeft = -1;
        props.dancersPadLeft = -1;

        props.cutoutMet1Left = -1;
        props.cutoutMet2Left = -1;
        props.cutoutMet3Left = -1;
        props.cutoutMet4Left = -1;
        props.cutoutMet5Left = -1;

        if (props.metatarsalgia === ConditionSide.right) props.metatarsalgia = ConditionSide.both;
        else if (props.metatarsalgia === ConditionSide.left) props.metatarsalgia = ConditionSide.none;
        if (props.halluxLimitus === ConditionSide.right) props.halluxLimitus = ConditionSide.both;
        else if (props.halluxLimitus === ConditionSide.left) props.halluxLimitus = ConditionSide.none;
        if (props.sesamoiditis === ConditionSide.right) props.sesamoiditis = ConditionSide.both;
        else if (props.sesamoiditis === ConditionSide.left) props.sesamoiditis = ConditionSide.none;
    }
    useDesignStore.getState().setDesign(design);
    useDesignStore.setState({ designLoaded: true });

    const saveSettings = getDefaultSaveSettings();
    // if (right.additions.length > 0) 
        saveSettings.replaceAdditons = true;
    saveSettings.updateInsoleMesh = saveSettings.updateAutoProperties = saveSettings.now = true;
    await scheduleAutosave(`Mirror`, saveSettings);
    const event = new CustomEvent('refreshAutomaticComponents');
    document.dispatchEvent(event);
}

export async function mirrorToRight(): Promise<void> {
    useDesignStore.setState({ mirrorLoaded : true});

    const design = useDesignStore.getState().insoleDesign;
    if (!design) return;

    const left = design.insoles.find(ins => ins.side === "left");
    const right = design.insoles.find(ins => ins.side === "right");

    if (!left || !right) return;

    const leftCloned = Insole.cloneFrom(left);
    const mirroredGeom = leftCloned.mirror();
    if (mirroredGeom) {
        right.lowpolyBufferGeometry = mirroredGeom;
    }

    right.additions.length = 0;


    for (const addition of left.additions) {
        const cloned = Addition.cloneFrom(addition);
        cloned.foot = 'right';
        cloned.mirror();
        right.additions.push(cloned);
    }

    right.profileCurveType = left.profileCurveType;
    right.gcodeText = left.gcodeText;


    const props = design.autoProperties;
    if (props) {
        props.profileCurveRight = props.profileCurveLeft;
        props.heelDepthRightY = props.heelDepthLeftY;

        props.metatarSalBarRight = -1;
        props.metatarSalPadRight = -1;
        props.mortonsExtensionRight = -1;
        props.dancersPadRight = -1;

        props.cutoutMet1Right = -1;
        props.cutoutMet2Right = -1;
        props.cutoutMet3Right = -1;
        props.cutoutMet4Right = -1;
        props.cutoutMet5Right = -1;

        if (props.metatarsalgia === ConditionSide.left) props.metatarsalgia = ConditionSide.both;
        else if (props.metatarsalgia === ConditionSide.right) props.metatarsalgia = ConditionSide.none;
        if (props.halluxLimitus === ConditionSide.left) props.halluxLimitus = ConditionSide.both;
        else if (props.halluxLimitus === ConditionSide.right) props.halluxLimitus = ConditionSide.none;
        if (props.sesamoiditis === ConditionSide.left) props.sesamoiditis = ConditionSide.both;
        else if (props.sesamoiditis === ConditionSide.right) props.sesamoiditis = ConditionSide.none;

    }

    useDesignStore.getState().setDesign(design);
    useDesignStore.setState({ designLoaded: true });

    const saveSettings = getDefaultSaveSettings();
    // if (left.additions.length > 0) 
        saveSettings.replaceAdditons = true;
    saveSettings.updateInsoleMesh = saveSettings.updateAutoProperties = saveSettings.now = true;
    await scheduleAutosave(`Mirror`, saveSettings);
    const event = new CustomEvent('refreshAutomaticComponents');
    document.dispatchEvent(event);
}
